module.exports = __webpack_public_path__ + "media/pikachu.b6d6ad06.wav";